<template>
  <div class="ml-4 w-50">
    <div class="row text-primary mb-4" style="font-size: 1rem;">
      <b class="mr-1">Instrucciones: </b> {{instructions}}
    </div>

    <div class="row mb-4" style="width: 40rem;">
      <div class="col-5">
        <table id="fractions">
          <tbody>
              <tr>
                  <td class="text-primary text-right">Numerador:</td>
                  <td><input v-model="firstNumerator" @change="firstNumerator = parseInt(firstNumerator)" :disabled="fractions[0].numeratorDisabled || (maxAttempts > 0 && remainingAttempts == 0)" id="num1" type="number" size="2" maxlength="2" style="width: 2em; font-size: 5em; text-align: center;"></td>
                  <td style="padding-bottom: 7rem;" v-if="isShowingStrip && isShowingFirstStrip">
                    <div id="strip1" style="position: absolute;z-index: 1;background-color: white;">
                      <table class="w-100" v-for="(row, index) in currentStrip" :key="`row-${index}`">
                        <td
                          v-for="cell in row"
                          :style="`
                            background-color: ${cell.backgroundColor};
                            width: ${cell.width};
                            height: 1rem;
                            font-size: 0.8rem;
                            vertical-align: center;
                            border-style: solid;
                            border-radius: 6px;
                          `"
                          class="text-white text-center"
                          :key="`cell-${cell.id}`"
                        >
                          {{cell.value}}
                        </td>
                      </table>
                    </div>
                  </td>
              </tr>
              <tr>
                  <td class="text-primary text-right">Denominador:</td>
                  <td><input v-model="firstDenominator" @change="firstDenominator = parseInt(firstDenominator)" :disabled="fractions[0].denominatorDisabled || (maxAttempts > 0 && remainingAttempts == 0)" id="den1" type="number" size="2" maxlength="2" style="width: 2em; font-size: 5em; text-align: center;"></td>
              </tr>
              <tr v-if="showStrip">
                <td></td>
                <td class="text-center">
                  <button class="btn btn-link text-primary" :disabled="!firstDenominator" @click="showStripByName('first')">
                    <template v-if="!isShowingFirstStrip">
                      <i class="fas fa-eye"></i>
                      Ver regleta
                    </template>
                    <template v-else>
                      <i class="fas fa-eye-slash"></i>
                      Ocultar regleta
                    </template>
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
      <div class="col-2 pt-6 d-flex align-items-center justify-content-center">
        <h1 class="text-primary">=</h1>
      </div>
      <div class="col-5">
        <table id="fractions">
          <tbody>
              <tr>
                  <td><input v-model="secondNumerator" @change="secondNumerator = parseInt(secondNumerator)" :disabled="fractions[1].numeratorDisabled || (maxAttempts > 0 && remainingAttempts == 0)" id="num1" type="number" size="2" maxlength="2" style="width: 2em; font-size: 5em; text-align: center;"></td>
                  <td style="padding-bottom: 7rem;" v-if="isShowingStrip && isShowingSecondStrip">
                    <div id="strip1" style="position: absolute;z-index: 1;background-color: white;">
                      <table class="w-100" v-for="(row, index) in currentSecondStrip" :key="`row-${index}`">
                        <td
                          v-for="cell in row"
                          :style="`
                            background-color: ${cell.backgroundColor};
                            width: ${cell.width};
                            height: 1rem;
                            font-size: 0.8rem;
                            vertical-align: center;
                            border-style: solid;
                            border-radius: 6px;
                          `"
                          class="text-white text-center"
                          :key="`cell-${cell.id}`"
                        >
                          {{cell.value}}
                        </td>
                      </table>
                    </div>
                  </td>
              </tr>
              <tr>
                  <td><input v-model="secondDenominator" @change="secondDenominator = parseInt(secondDenominator)" :disabled="fractions[1].denominatorDisabled || (maxAttempts > 0 && remainingAttempts == 0)" id="den1" type="number" size="2" maxlength="2" style="width: 2em; font-size: 5em; text-align: center;"></td>
              </tr>
              <tr v-if="showStrip">
                <td class="text-center">
                  <button class="btn btn-link text-primary" :disabled="!secondDenominator" @click="showStripByName('second')">
                    <template v-if="!isShowingSecondStrip">
                      <i class="fas fa-eye"></i>
                      Ver regleta
                    </template>
                    <template v-else>
                      <i class="fas fa-eye-slash"></i>
                      Ocultar regleta
                    </template>
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div style="width: 40rem;" class="row">
      <alert
        type="danger"
        dismissible
        @dismiss="errorMessage = ''"
        :isVisible="errorMessage ? true : false"
      >
        <i class="fas fa-exclamation-circle"></i>
        <strong> ¡Ups!</strong>
        {{errorMessage}}
      </alert>

      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div style="width: 40rem;" class="row d-flex justify-content-end">
      <!--<button v-if="maxAttempts > 0 && remainingAttempts == 0" class="btn btn-primary" @click="reset()">
        <i class="fas fa-undo"></i>
        Reiniciar
      </button>-->
      <button v-if="maxAttempts > 0 && remainingAttempts == 0" disabled class="btn btn-danger">
        Evaluar
      </button>
      <button v-else class="btn btn-primary" @click="evaluate()">Evaluar</button>
    </div>

    <!--<div style="width: 40rem;" >
      <table class="w-100" v-for="(row, index) in currentStrip" :key="`row-${index}`">
        <td
          v-for="cell in row"
          :style="`
            background-color: ${cell.backgroundColor};
            width: ${cell.width};
            height: 1rem;
            font-size: 0.8rem;
            vertical-align: center;
            border-style: solid;
            border-radius: 10px;
          `"
          class="text-white text-center"
          :key="`cell-${cell.id}`"
        >
          {{cell.value}}
        </td>
      </table>
    </div>-->

  </div>
</template>
<script>
import Button from '../Button.vue';
export default {
  components: { Button },
  name: 'fractions',
  props: {
    instructions: {
      type: String,
      default: 'Rellena los campos en blanco para hacer coincidir las fracciones.'
    },
    fractions: {
      type: Array,
      // Los valores predeterminados del objeto o matriz deben devolverse desde
      // una función de fábrica
      default: function () { 
        return [{
          numerator: '',
          numeratorDisabled: false,
          denominator: '',
          denominatorDisabled: false
        },
        {
          numerator: '',
          numeratorDisabled: false,
          denominator: '',
          denominatorDisabled: false
        }]
      }
    },
    showStrip: {
      type: Boolean,
      default: true
    },
    maxAttempts: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      firstNumerator: this.fractions[0].numerator,
      firstCorrectNumerator: this.fractions[0].correctNumerator,
      firstDenominator: this.fractions[0].denominator,
      firstCorrectDenominator: this.fractions[0].correctDenominator,
      secondNumerator: this.fractions[1].numerator,
      secondCorrectNumerator: this.fractions[1].correctNumerator,
      secondDenominator: this.fractions[1].denominator,
      secondCorrectDenominator: this.fractions[1].correctDenominator,
      errorMessage: '',
      successMessage: '',
      attemptsMessage: '',
      isShowingFirstStrip: false,
      isShowingSecondStrip: false,
      remainingAttempts: this.maxAttempts,
      colors: [
        "#43AA8B", "#4D908E", "#577590", "#277DA1", "#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F", "#90BE6D",
        "#f72585", "#b5179e", "#7209b7", "#560bad", "#480ca8", "#3a0ca3", "#3f37c9", "#4361ee", "#4895ef", "#4cc9f0",
        "#43AA8B", "#4D908E", "#577590", "#277DA1", "#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F", "#90BE6D",
      ],
    }
  },
  watch: {
    firstNumerator () {
      if (this.firstNumerator && this.firstNumerator <= 0) this.firstNumerator = 1;
    },
    firstDenominator () {
      if (this.firstDenominator && this.firstDenominator <= 0) this.firstDenominator = 1;
    },
    secondDenominator () {
      if (this.secondDenominator && this.secondDenominator <= 0) this.secondDenominator = 1;
    },
    secondNumerator () {
      if (this.secondNumerator && this.secondNumerator <= 0) this.secondNumerator = 1;
    }
  },
  computed: {
    isShowingStrip () {
      if (!this.showStrip) return false;
      return true;
    },
    currentStrip() {
      let denominatorStrip = !this.firstDenominator ? 0 : this.firstDenominator;
      return this.getStrip(denominatorStrip);
    },
    currentSecondStrip() {
      let denominatorStrip = !this.secondDenominator ? 0 : this.secondDenominator;
      return this.getStrip(denominatorStrip);
    }
  },
  methods: {
    evaluate() {
      this.errorMessage = '';
      this.successMessage = '';
      this.attemptsMessage = ''

      if (
        !this.firstNumerator
        || !this.firstDenominator
        || !this.secondNumerator
        || !this.secondDenominator
      ) {
        this.errorMessage = 'Llena todos los campos para continuar';
        return;
      }

      if (
        this.firstNumerator <= 0
        || this.firstDenominator <= 0
        || this.secondNumerator <= 0
        || this.secondDenominator <= 0
      ) {
        this.errorMessage = 'Todos los numeradores y denominadores deben ser siempre mayor a cero';
        return;
      }

      if (
        this.firstNumerator == this.secondNumerator
        && this.firstDenominator == this.secondDenominator
      ) {
        this.errorMessage = 'No puedes ingresar las mismas fracciones';
        return;
      }

      let isCorrect = (this.firstNumerator / this.firstDenominator) == (this.secondNumerator / this.secondDenominator);

      if (isCorrect) this.successMessage = '¡Excelente!, las fracciones coinciden';
      else {
        if (this.maxAttempts > 0) {
          this.remainingAttempts = this.remainingAttempts - 1;
          if (this.remainingAttempts == 0) {
            this.firstNumerator = this.firstCorrectNumerator;
            this.secondNumerator = this.secondCorrectNumerator;
            this.firstDenominator = this.firstCorrectDenominator;
            this.secondDenominator = this.secondCorrectDenominator;
            this.errorMessage = 'Se acabarón tus intentos, revisa las respuestas correctas';
          } else this.errorMessage = 'Las fracciones no coinciden, te quedan ' + this.remainingAttempts + ' intentos';
        }
        else this.errorMessage = 'Las fracciones no coinciden';
      }

      this.$emit('evaluated', {
        value: isCorrect,
        fractions: [
          {
            numerator: this.firstNumerator,
            denominator: this.firstDenominator
          },
          {
            numerator: this.secondNumerator,
            denominator: this.secondDenominator
          }
        ]
      });
    },
    showStripByName(stripName) {
      if (stripName == 'first') {
        this.isShowingFirstStrip = !this.isShowingFirstStrip;
        this.isShowingSecondStrip = false;
      } else {
        this.isShowingSecondStrip = !this.isShowingSecondStrip;
        this.isShowingFirstStrip = false;
      }
    },
    getStrip(denominatorStrip) {
      let maxRows = 9;
      let strip = [];
      
      if (denominatorStrip == 0) return strip;

      for (let index = 0; index < maxRows; index++) {
        let fraction = 0;
        if (denominatorStrip == 1 || index == 0) fraction = index + 1; 
        //else fraction = Math.pow(denominatorStrip, index);
        else fraction = denominatorStrip * index;

        if (fraction > 27) {
          break;
        }
        let colorIndex = index;
        if (colorIndex > this.colors.length) {
          colorIndex = colorIndex % this.colors.length;
        }
        const color = this.colors[colorIndex];
        let row = []
        const width = ((1/(fraction))*100);
        for (let cellIndex = 1; cellIndex <= fraction; cellIndex++) {
          let cell = {
            backgroundColor: color,
            id: fraction + ":" + cellIndex,
            value: fraction,
            width: width + "%"
          }
          row.push(cell);
        }
        strip.push(row);
      }

      return strip;
    },
    reset() {
      this.firstNumerator = this.fractions[0].numerator;
      this.firstDenominator = this.fractions[0].denominator;
      this.secondNumerator = this.fractions[1].numerator;
      this.secondDenominator = this.fractions[1].denominator;
      this.errorMessage = '';
      this.successMessage = '';
      this.isShowingFirstStrip = false;
      this.isShowingSecondStrip = false;
      this.remainingAttempts = this.maxAttempts;
    }
  },
}
</script>
